export const callSettingType = {
  GET_CALL_SETTING_DATA: "GET_CALL_SETTING_DATA",
  GET_ALL_VOICES_DATA: "GET_ALL_VOICES_DATA",
  CLEAR_CALL_SETTING: "CLEAR_CALL_SETTING",
};
